// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import FolderTreeList2 from './FolderTreeList2';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import FolderAddDialog from './FolderAddDialog';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import SendIcon from '@mui/icons-material/Send';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ConfirmDialog from './ConfirmDialog';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
// import ChatIcon from '@mui/icons-material/Chat';
import SelMemberDialog from './SelMemberDialog';
import SelFolderDialog from './SelFolderDialog';
import CopyDmsDialog from './CopyDmsDialog';
import dayjs from "dayjs"

// let LINKED_FOLDER_RAG_IMG = "images/ai-folder-24.png";

// function RagFolderIcon({ disabled }) {
//   return (
//     <Box
//       component="img"
//       src={LINKED_FOLDER_RAG_IMG}
//       alt="RAG"
//       sx={{
//         width: 22,
//         height: 22,
//         objectFit: "contain",

//         // dim when disabled
//         opacity: disabled ? 0.4 : 1,
//         filter: disabled ? "grayscale(100%)" : "none",
//       }}
//     />
//   );
// }

// RagFolderIcon.propTypes = {
//   disabled: PropTypes.bool,
// };

export default function FolderStructureTab(props) {
  const { sysID, onUpdate } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const curDept = gState?.depts?.find(d => d.DeptCode == sysID);
  const adminLevel = curDept?.AdminLevel || 0;
  const isDataAdmin = ((adminLevel & DmsCommon.SystemAdminEnum.saData) == DmsCommon.SystemAdminEnum.saData);
  const isSecurtyAdmin = ((adminLevel & DmsCommon.SystemAdminEnum.saSecurity) == DmsCommon.SystemAdminEnum.saSecurity);


  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  // const [folders, setFolders] = useState([]);
  // const [selFolderID, setSelFolderID] = useState(DmsCommon.VOID_FOLDER_ID)
  const [folderState, setFolderState] = useState({
    folders: [],
    selFolderID: DmsCommon.VOID_FOLDER_ID,
    // selFolderNode: null,
  })



  useEffect(() => {
    // console.log("useEffect FolderStructureTab(did mounted)");
    refreshData();
  }, []);

  // useEffect(() => {
  //   console.log("useEffect FolderStructureTab[selFolderID]", folderState.selFolderID);

  // }, [folderState.selFolderID]);

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });
  }

  const [limitedRootFolderIDs, setLimitedRootFolderIDs] = useState(null);

  const refreshData = async (aSelFolderID) => {
    // console.log("FolderStructureTab refreshData", aSelFolderID);

    setShowLoading(true);

    try {
      const [vRstFolders, vAdminFolders] = await Promise.all([
        DmsService.logIfLongRunningGetFoldersPromise(gState.sessionID, sysID, true),
        DmsService.getAdminFolderByUserPromise(gState.sessionID, sysID),
      ]);
      // console.log("vRstFolders", vRstFolders);

      setShowLoading(false);

      let vFolders = vRstFolders;

      // Do it when user is not security admin
      if (isSecurtyAdmin === false) {

        // Remove all shared Folder which is not created by user
        vFolders = vRstFolders.filter(item => {
          return (item.LinkedFolderID == 0 || item.CreatedBy == gState.userID);
        })
      }

      // console.log("isDataAdmin", isDataAdmin);

      if (isDataAdmin === true) {
        setLimitedRootFolderIDs(null);
      } else {
        const vAdminFolderIDs = vAdminFolders.map(f => f.FolderID);
        // console.log("vAdminFolderIDs", vAdminFolderIDs);
        setLimitedRootFolderIDs(vAdminFolderIDs);
      }

      if (aSelFolderID) {
        // setFolderState({...folderState, folders: vFolders, selFolderID: aSelFolderID});
        setFolderState((prevState) => { return { ...prevState, folders: vFolders, selFolderID: aSelFolderID } });
      } else {
        // setFolderState({...folderState, folders: vFolders});
        setFolderState((prevState) => { return { ...prevState, folders: vFolders, selFolderID: DmsCommon.VOID_FOLDER_ID } });
      }

    } catch (e) {
      setShowLoading(false);

      // setFolders([]);
      // setFolderState({...folderState, folders: []})
      setFolderState((prevState) => { return { ...prevState, folders: [], selFolderID: DmsCommon.VOID_FOLDER_ID } });


      // console.log('Fail: ', e);
      onCatchPromiseError(e);
      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);


    }


  }


  const handleChangeFolderID = (AFolderID, AFolderNode) => {
    // console.log("handleChangeFolderID", AFolderID);
    // console.log("handleChangeFolderID", AFolderNode);

    setFolderState((prevState) => { return { ...prevState, selFolderID: AFolderID } });
    // setFolderState((prevState) => { return { ...prevState, selFolderID: AFolderID, selFolderNode: AFolderNode } });
  }




  // const [openAddDialog, setOpenAddDialog] = useState(false);



  const [openConfirmAddPersonalDialog, setOpenConfirmAddPersonalDialog] = useState(false);
  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
  const [members, setMembers] = useState([]);
  const [groups, setGroups] = useState([]);

  const handleConfirmAddPersonalClick = () => {
    // console.log("handleConfirmAddPersonalClick");

    setOpenConfirmAddPersonalDialog(false);

    setShowLoading(true);

    const p1 = DmsService.getMembersPromise(gState.sessionID, sysID, false);
    const p2 = DmsService.getGroupsPromise(gState.sessionID, sysID);

    Promise.all([p1, p2]).then((values) => {
      setShowLoading(false);
      // console.log("Promise.all", values);

      const [v1, v2] = values;

      setMembers(v1);
      setGroups(v2);
      setOpenAddUserDialog(true);
    })
      .catch(e => {
        setShowLoading(false);
        // setErrMsg(e.errMsg || e.message);
        // setShowError(true);

        onCatchPromiseError(e);
      })


  }


  const handleSelectAddUsers = async (aUsers) => {
    // console.log("handleSelectAddUsers aUsers", aUsers);

    setOpenAddUserDialog(false);

    if (aUsers.length > 0) {
      const vSelUser = aUsers[0];
      // console.log("vSelUser", vSelUser);

      const vUserID = vSelUser.UserID;
      const vFolderName = vSelUser.FullName;

      setShowLoading(true);

      try {
        const [vNewFolderID, vFolderExists] = await DmsService.folderAddPromise(
          gState.sessionID, sysID, vFolderName, folderState.selFolderID);

        // Grant Full control Folder Permission to folder owner
        const vPerms = [{ "userID": vUserID, "grade": DmsCommon.AccessRightEnum.arFullControl }];

        await Promise.all([
          DmsService.folderUpdatePromise(gState.sessionID, sysID, vNewFolderID, vFolderName, true, false),
          DmsService.folderRightUpdatePromise(gState.sessionID, sysID, vNewFolderID, false, true, vPerms),
          DmsService.folderAdminUpdatePromise(gState.sessionID, sysID, vNewFolderID, [vUserID])
        ]);

        setShowLoading(false);

        refreshData();

        onUpdate && onUpdate();

      } catch (e) {
        setShowLoading(false);

        // setErrMsg(e.errMsg || e.message);
        // setShowError(true);

        onCatchPromiseError(e);

      }

    }


  }


  const [openFolderAddDialog, setOpenFolderAddDialog] = useState(false);

  const [editMode, setEditMode] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [folderParentID, setFolderParentID] = useState(0);
  const [mobileAccessible, setMobileAccessible] = useState(false);
  const [internetAccess, setInternetAccess] = useState(false);
  const [ragEnabled, setRagEnabled] = useState(false);
  const [isMonitorFolder, setIsMonitorFolder] = useState(false);

  const handleAddClick = () => {
    // console.log("selFolderID", folderState.selFolderID);


    try {

      const vIsPersonalFolder = (folderState.selFolderID == DmsCommon.PERSONAL_FOLDER_ID);

      if (vIsPersonalFolder == true) {
        // console.log("adminLevel", adminLevel);

        if ((adminLevel & DmsCommon.SystemAdminEnum.saData) != DmsCommon.SystemAdminEnum.saData) {
          throw new Error("Only Data Admin can add Personal Folder!");
        }

        setOpenConfirmAddPersonalDialog(true);

      } else {

        const vSelFolder = folderState.folders.find(f => f.id == folderState.selFolderID);

        setEditMode(false);
        setIsMonitorFolder(false);
        setInternetAccess(false);

        setOpenFolderAddDialog(true);
      }


    }
    catch (e) {
      // setErrMsg(e.message);
      // setShowError(true);
      onCatchPromiseError(e);
    };

  }

  const handleAfterFolderAddOrUpdate = (aFolderID, aFolderName, aMobileAccess, aRagEnabled, aInternetAccess) => {
    // console.log("handleAfterFolderAddOrUpdate", aFolderID, aFolderName);

    setOpenFolderAddDialog(false);

    // console.log("folderState.folders", folderState.folders);

    if (editMode === true) {
      // Find the updated folder
      const vUpdateFolder = folderState.folders.find(f => f.id === aFolderID);

      // Rename folder
      setFolderState((prevState) => {
        const vFolders = prevState.folders.map(item => {
          const newItem = {
            ...item,
          }
          if (item.id === aFolderID) {
            newItem.FolderName = aFolderName;
            newItem.MobileAccessible = aMobileAccess;
            newItem.InternetAccess = aInternetAccess;
            newItem.RagEnabled = aRagEnabled;
          }
          // Update Rag status for subfolders
          if (vUpdateFolder && item.id !== aFolderID && item.FolderPath.startsWith(vUpdateFolder.FolderPath)) {
            newItem.RagEnabled = aRagEnabled;
          }

          return newItem;
        });

        return { ...prevState, folders: vFolders, selFolderID: aFolderID }
      });
    } else {

      // Add new folder object
      setFolderState((prevState) => {
        const vParentFolder = prevState.folders.find(f => f.id == prevState.selFolderID);

        const vFolders = prevState.folders.map(item => { return { ...item } });
        vFolders.push({
          "id": aFolderID,
          "FolderName": aFolderName,
          "FolderPath": `${vParentFolder ? vParentFolder.FolderPath + " >" : ""} ${aFolderName}`,
          "CreatedBy": gState.userID,
          "ParentID": vParentFolder?.id || prevState.selFolderID,
          "Grade": vParentFolder?.Grade || 0,
          "LinkedFolderID": 0,
          "MobileAccessible": aMobileAccess,
          "InternetAccess": aInternetAccess,
          "UnreadCnt": 0,
          "RagEnabled": aRagEnabled,
        })

        return { ...prevState, folders: vFolders, selFolderID: aFolderID }
      });
    }

    // refreshData(aNewFolderID);

    onUpdate && onUpdate();
  }


  const handleEditClick = () => {

    const vSelFolder = folderState.folders.find(f => f.id == folderState.selFolderID);
    // console.log("vSelFolder", vSelFolder);

    if (folderState.selFolderID == DmsCommon.ALL_FOLDER_ID) {
      setErrMsg("The root folder cannot be renamed!");
      setShowError(true);
    } else if (folderState.selFolderID == DmsCommon.PERSONAL_FOLDER_ID) {
      setErrMsg("The Personal folders cannot be renamed!");
      setShowError(true);
    } else {
      setEditMode(true);
      setFolderParentID(vSelFolder.ParentID);
      setFolderName(vSelFolder.FolderName);
      setMobileAccessible(vSelFolder.MobileAccessible);
      setInternetAccess(vSelFolder.InternetAccess || false);
      setRagEnabled(vSelFolder.RagEnabled);
      setIsMonitorFolder(vSelFolder.IsMonitorFolder || false);
      setOpenFolderAddDialog(true);
    }


  }

  const [openMoveFolderDialog, setOpenMoveFolderDialog] = useState(false);

  const handleMoveClick = () => {
    const vSelFolder = folderState.folders.find(f => f.id == folderState.selFolderID);
    // console.log("vSelFolder", vSelFolder);

    if (folderState.selFolderID == DmsCommon.ALL_FOLDER_ID) {
      setErrMsg("The root folder cannot be moved!");
      setShowError(true);
    } else if (folderState.selFolderID == DmsCommon.PERSONAL_FOLDER_ID || vSelFolder.ParentID == DmsCommon.PERSONAL_FOLDER_ID) {
      setErrMsg("The Personal folder cannot be moved!");
      setShowError(true);
    } else if (vSelFolder.LinkedFolderID != 0) {
      setErrMsg("Cannot move a Shortcut!");
      setShowError(true);
    } else {
      setOpenMoveFolderDialog(true);
    }

  }

  const [openCopyFolderDialog, setOpenCopyFolderDialog] = useState(false);


  const handleCopyClick = () => {
    const vSelFolder = folderState.folders.find(f => f.id == folderState.selFolderID);
    // console.log("vSelFolder", vSelFolder);

    if (folderState.selFolderID == DmsCommon.ALL_FOLDER_ID) {
      setErrMsg("The root folder cannot be copied!");
      setShowError(true);
    } else if (folderState.selFolderID == DmsCommon.PERSONAL_FOLDER_ID || vSelFolder.ParentID == DmsCommon.PERSONAL_FOLDER_ID) {
      setErrMsg("The Personal folder cannot be copied!");
      setShowError(true);
    } else if (vSelFolder.LinkedFolderID != 0) {
      setErrMsg("Cannot copy a Shortcut!");
      setShowError(true);
    } else {
      setOpenCopyFolderDialog(true);
    }
  }

  const [openCopyDmsDialog, setOpenCopyDmsDialog] = useState(false);

  const handleCopyToDMSClick = () => {
    // const vSelFolder = folderState.folders.find(f => f.id == folderState.selFolderID);
    // console.log("selFolderNode", folderState.selFolderNode);

    setOpenCopyDmsDialog(true);
  }


  const handleSelectedMoveFolder = async (aNewParentID) => {
    // console.log("aFolderID", aFolderID);

    setOpenMoveFolderDialog(false);


    setShowLoading(true);
    try {
      await DmsService.folderMovePromise(gState.sessionID, sysID, folderState.selFolderID, aNewParentID);

      setShowLoading(false);

      // Refresh Data
      // refreshData(aFolderID);

      setFolderState((prevState) => {
        const vSelFolderID = folderState.selFolderID;

        let vFolders = prevState.folders.map(item => {
          let newItem = {
            ...item,
          }
          if (newItem.id == vSelFolderID) {
            newItem.ParentID = aNewParentID;
          }

          return newItem;
        });

        return { ...prevState, folders: vFolders, selFolderID: vSelFolderID }
      });

      onUpdate && onUpdate();
    } catch (e) {
      setShowLoading(false);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);

    }

  }


  const handleSelectedCopyFolder = async (aFolderID) => {
    // console.log("aFolderID", aFolderID);

    setOpenCopyFolderDialog(false);


    setShowLoading(true);
    try {
      await DmsService.folderCopyPromise(gState.sessionID, sysID, folderState.selFolderID, aFolderID);

      setShowLoading(false);

      // Refresh Data
      refreshData(aFolderID);

      onUpdate && onUpdate();
    } catch (e) {
      setShowLoading(false);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);

    }

  }



  const handleDelClick = () => {

    setOpenDelConfirmDialog(true);
  }

  // const handleEnableRAGClick = async () => {

  //   const vSelFolder = folderState.folders.find(f => f.id == folderState.selFolderID);
  //   // console.log('vSelFolder :', vSelFolder);

  //   if (vSelFolder) {
  //     setShowLoading(true);
  //     try {
  //       await DmsService.folderUpdateRagPromise(gState.sessionID, sysID, vSelFolder.id,
  //         !vSelFolder.RagEnabled);

  //       setShowLoading(false);

  //       // Rename folder
  //       setFolderState((prevState) => {
  //         const vFolders = prevState.folders.map(item => {
  //           const newItem = {
  //             ...item,
  //           }
  //           if (item.id === vSelFolder.id) {
  //             newItem.RagEnabled = !newItem.RagEnabled;
  //           }
  //           return newItem;
  //         });

  //         return { ...prevState, folders: vFolders, selFolderID: vSelFolder.id }
  //       });

  //       onUpdate && onUpdate();

  //     } catch (e) {
  //       setShowLoading(false);

  //       onCatchPromiseError(e);

  //     }
  //   }


  // }

  const [openDelConfirmDialog, setOpenDelConfirmDialog] = useState(false);

  const handleConfirmDeleteClick = async () => {
    // console.log("handleConfirmDeleteClick", folderState.selFolderID);


    setOpenDelConfirmDialog(false);

    setShowLoading(true);

    try {
      await DmsService.folderDelPromise(gState.sessionID, sysID, folderState.selFolderID);

      setShowLoading(false);

      // // Refresh Data after setting selFolderID
      // const vSelFolder = folderState.folders.find(f => f.id == folderState.selFolderID);
      // // console.log("selFolder", vSelFolder);
      // refreshData(vSelFolder.ParentID);


      setFolderState((prevState) => {
        const vSelFolder = folderState.folders.find(f => f.id == folderState.selFolderID);
        const vParentID = vSelFolder.ParentID;

        let vFolders = prevState.folders.filter(item => {
          const newItem = {
            ...item,
          }
          return newItem.id != folderState.selFolderID;
        });

        // Select the parent folder
        return { ...prevState, folders: vFolders, selFolderID: vParentID }
      });


      onUpdate && onUpdate();

    } catch (e) {
      setShowLoading(false);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);

    }
  }

  const curSelFolderID = folderState?.selFolderID;
  const curSelFolder = folderState?.folders?.find(f => f.id === curSelFolderID)
  // console.log("vCurSelFolder", curSelFolder);

  const disableAdd = (curSelFolderID == undefined || curSelFolderID == DmsCommon.VOID_FOLDER_ID || curSelFolder?.IsMonitorFolder === true);
  const disableEdit = (curSelFolderID == undefined ||
    [DmsCommon.VOID_FOLDER_ID, DmsCommon.ALL_FOLDER_ID, DmsCommon.PERSONAL_FOLDER_ID].includes(curSelFolderID));
  const disableMoveCopyDelete = (disableEdit || curSelFolder?.IsMonitorFolder === true);

  // console.log('gState.userID.toUpperCase()', gState.userID.toUpperCase());
  const hasPermissionForCopyToDMS = ['hctapt1', 'edpderc', 'itddev01'].includes(gState.userID.toLowerCase());
  const disableCopyToDMS =
    !(curSelFolder?.ParentID === 0 && curSelFolder?.id !== DmsCommon.PERSONAL_FOLDER_ID) || curSelFolder?.IsMonitorFolder === true;

  // const disableEnableRAG = (curSelFolderID == undefined ||
  //   [DmsCommon.VOID_FOLDER_ID, DmsCommon.ALL_FOLDER_ID, DmsCommon.PERSONAL_FOLDER_ID].includes(curSelFolderID));
  // const isRAGEnabled = curSelFolder?.RagEnabled === true;

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column',
      height: "70vh"
      // height: 1, maxHeight: 1, overflow: 'auto'
    }} >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />


      <ConfirmDialog
        open={openConfirmAddPersonalDialog}
        text="Are you sure to add a Personal Folder?"
        confirmBtnCaption='Add Folder'
        onCancelClick={() => {
          setOpenConfirmAddPersonalDialog(false);
        }}
        onConfirmClick={handleConfirmAddPersonalClick}
      />
      <SelMemberDialog
        open={openAddUserDialog}
        onClose={() => { setOpenAddUserDialog(false) }}
        members={members}
        groups={groups}
        onSelect={handleSelectAddUsers}
        disableGroupTab
        disableMultiSelectMember
      />

      <FolderAddDialog
        sysID={sysID}
        open={openFolderAddDialog}
        onClose={() => setOpenFolderAddDialog(false)}
        afterUpdate={handleAfterFolderAddOrUpdate}

        editMode={editMode}
        createFromFolderID={folderState.selFolderID}
        folderID={folderState.selFolderID}
        folderParentID={folderParentID}
        folderName={folderName}
        mobileAccessible={mobileAccessible}
        internetAccess={internetAccess}
        ragEnabled={ragEnabled}
        isMonitorFolder={isMonitorFolder}
      />

      <ConfirmDialog
        open={openDelConfirmDialog}
        text={"Delete the selected Folder?"}
        confirmBtnCaption='Delete'
        onCancelClick={() => {
          setOpenDelConfirmDialog(false);
        }}
        onConfirmClick={handleConfirmDeleteClick}
      />

      <SelFolderDialog
        open={openMoveFolderDialog}
        onClose={() => setOpenMoveFolderDialog(false)}
        folders={folderState.folders}
        limitedRootFolderIDs={limitedRootFolderIDs}
        iniFolderID={folderState.selFolderID}
        disableAllFolder={!isDataAdmin}
        disablePersonalFolder={!isDataAdmin}
        onSelectFolderID={handleSelectedMoveFolder}

      />

      <SelFolderDialog
        open={openCopyFolderDialog}
        onClose={() => setOpenCopyFolderDialog(false)}
        folders={folderState.folders}
        limitedRootFolderIDs={limitedRootFolderIDs}
        iniFolderID={folderState.selFolderID}
        disableAllFolder={!isDataAdmin}
        disablePersonalFolder={!isDataAdmin}
        disablePhyLocFolder
        onSelectFolderID={handleSelectedCopyFolder}

      />

      <CopyDmsDialog
        open={openCopyDmsDialog}
        onClose={() => setOpenCopyDmsDialog(false)}
        sysID={sysID}
        folderID={folderState?.selFolderID}
        folders={folderState?.folders}
      />

      <div className="ag-theme-material" style={{ width: '100%', height: '100%', bgcolor: 'yellow' }}>
        <Box sx={{ py: 1, px: 1 }} >

          <Button disabled={disableAdd} startIcon={<AddIcon />} onClick={handleAddClick} >
            Add
          </Button>

          <Button disabled={disableEdit} startIcon={<EditIcon />} onClick={handleEditClick} >
            Edit
          </Button>

          <Button disabled={disableMoveCopyDelete} startIcon={<DriveFileMoveIcon />} onClick={handleMoveClick}  >
            Move
          </Button>


          <Button disabled={disableMoveCopyDelete} startIcon={<ContentCopyIcon />} onClick={handleCopyClick}  >
            Copy Structure
          </Button>

          {hasPermissionForCopyToDMS &&
            <Button disabled={disableCopyToDMS} startIcon={<ContentCopyIcon />} onClick={handleCopyToDMSClick}  >
              Copy To DMS
            </Button>
          }

          {/* <Button disabled={folderState.selFolderID == DmsCommon.VOID_FOLDER_ID} startIcon={<EditIcon />}  >
            Share
          </Button> */}


          <Button disabled={disableMoveCopyDelete} startIcon={<DeleteIcon />} onClick={handleDelClick} >
            Delete
          </Button>

        </Box>
        <Box sx={{
          display: 'flex', p: 0, height: 1, maxHeight: 1, overflow: 'auto', width: 1
        }} >
          <FolderTreeList2
            folders={folderState.folders}
            limitedRootFolderIDs={limitedRootFolderIDs}
            selFolderID={folderState.selFolderID}
            onChangeFolderID={handleChangeFolderID}
            disableAllFolder={!isDataAdmin}
            disablePersonalFolder={!isDataAdmin}
            disableReadCnt
            enableMobileAccessDisplay
          />

        </Box>

      </div>

    </Box>


  );
}

FolderStructureTab.propTypes = {
  sysID: PropTypes.string,
  // adminLevel: PropTypes.number,
  onUpdate: PropTypes.func,
};
